module.exports = __webpack_public_path__ + "static/img/bg-top@2x.444fcaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-top@2x.png
// module id = 357
// module chunks = 0